import { db } from "./main.js";
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
} from "firebase/firestore";
import { formatPetNameForURL } from "./utilities.js";

// Function to display premium pets for a specific state on the page
window.addPetOnResults = async function displayPremiumPetOnResults(state) {
  const citiesRef = collection(db, `missing/lost/states/${state}/cities`);
  const citiesSnapshot = await getDocs(citiesRef);
  const cityPromises = [];

  citiesSnapshot.forEach((cityDoc) => {
    const petsRef = collection(
      db,
      `missing/lost/states/${state}/cities/${cityDoc.id}/pets`
    );

    const petQuery = query(petsRef, orderBy("missing_date", "asc"), limit(1));

    cityPromises.push(getDocs(petQuery));
  });

  const citySnapshots = await Promise.all(cityPromises);
  const petData = citySnapshots
    .map((citySnapshot) => {
      const pets = citySnapshot.docs.map((petDoc) => petDoc.data());
      return pets;
    })
    .flat();

  if (petData.length > 0) {
    $("#loading-spinner-widget").show();

    const petDiv = document.createElement("div");
    petDiv.className = "pet";

    const titleElem = document.createElement("div");
    titleElem.textContent = "Have You Seen Me?";
    titleElem.className = "lost-widget-heading";
    petDiv.appendChild(titleElem);

    const imageElem = document.createElement("img");
    imageElem.className = "pet-image";
    imageElem.alt = petData[0].pet_name;
    imageElem.src = petData[0].image_url_one;
    petDiv.appendChild(imageElem);

    const petInfoDiv = document.createElement("div");
    petInfoDiv.className = "pet-info";

    const nameElem = document.createElement("div");
    nameElem.textContent = petData[0].pet_name;
    nameElem.className = "pet-info-name";
    petInfoDiv.appendChild(nameElem);

    const fromElem = document.createElement("div");
    const iconElem = document.createElement("i");
    iconElem.className = "icon-location-arrow";
    fromElem.appendChild(iconElem);
    fromElem.textContent = `${petData[0].city}, ${petData[0].state}`;
    fromElem.className = "pet-info-from";
    petInfoDiv.appendChild(fromElem);

    const date = new Date(petData[0].missing_date);
    const options = { month: "short", day: "numeric", year: "numeric" };
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
      date
    );
    const dateElem = document.createElement("p");
    dateElem.textContent = `Missing since ${formattedDate}`;
    dateElem.className = "pet-info-date";
    petInfoDiv.appendChild(dateElem);

    const hrElem = document.createElement("hr");
    petInfoDiv.appendChild(hrElem);

    const detailsDivElem = document.createElement("div");
    detailsDivElem.className = "details-button-container";

    const detailsBtnElem = document.createElement("button");
    detailsBtnElem.textContent = `View Details`;

    detailsDivElem.appendChild(detailsBtnElem);

    petInfoDiv.appendChild(detailsDivElem);

    petDiv.appendChild(petInfoDiv);
    const formattedPetName = formatPetNameForURL(petData[0].pet_name);
    const linkElem = document.createElement("a");
    linkElem.href = `/missing/pet/${petData[0].uid}/${formattedPetName}/`;
    linkElem.appendChild(petDiv);

    $("#loading-spinner-widget").hide();
    const petContainer = document.getElementById("pet-container-widget");
    petContainer.innerHTML = "";
    petContainer.appendChild(linkElem);
  } else {
    $("#loading-spinner-widget").hide();
    const petContainer = document.getElementById("pet-container-widget");
    petContainer.innerHTML = "";
  }
};
